import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {HttpService2} from "../../../../shared/services/http-service-2.0/http2.0.service";
import {FormGetResult, FormPostResult} from '../../../../shared/services/http-service-2.0/http.interface';
import {map} from "rxjs/operators";
import {LoggerService} from "../../../../shared/services/logger/logger.service";
import {IControlException, IControlExceptionList, IControlFormOption} from "./global-popup-control-exception-edit.interface";
import {IControlProgramList} from "../global-popup-control-program-edit/global-popup-control-program-edit.interface";


@Injectable()
export class GlobalPopupControlExceptionEditService {
    constructor(protected httpService2: HttpService2, protected logger:LoggerService) {}

    public getControlExceptionList(): Observable<IControlExceptionList[]>{
        this.logger.log('[GlobalPopupControlExceptionEditService] ' + 'Get control exception list')
        return <Observable<IControlExceptionList[]>>this.httpService2.doGetRequest(`control-form/control-program-exception/list`, true);
    }

    public getControlException(controlExceptionId:number): Observable<IControlException>{
        this.logger.log('[GlobalPopupControlExceptionEditService] ' + 'Get control exception by id')
        return <Observable<IControlException>>this.httpService2.doGetRequest(`control-form/control-program-exception/get/${controlExceptionId}`, true);
    }

    public saveControlException(controlProgram:IControlException): Observable<FormPostResult>{
        this.logger.log('[GlobalPopupControlExceptionEditService] ' + 'Save control exception')
        let postValues: any = controlProgram;
        return this.httpService2.doFormPostRequest(`control-form/control-program-exception/edit`, postValues, true).pipe(
            map((result) => {
                return result;
            })
        );
    }

    public deleteControlException(controlExceptionId:number): Observable<FormGetResult>{
        this.logger.log('[GlobalPopupControlExceptionEditService] ' + 'Delete control exception')
        return <Observable<FormGetResult>>this.httpService2.doGetRequest(`control-form/control-program-exception/delete/${controlExceptionId}`, true);
    }

    public getControlProgramsList(): Observable<IControlProgramList[]>{
        this.logger.log('[GlobalPopupControlProgramEditService] ' + 'Get control program list')
        return <Observable<IControlProgramList[]>>this.httpService2.doGetRequest(`control-form/control-program/list`, true);
    }

    public getDimgroepList(): Observable<IControlFormOption[]>{
        this.logger.log('[GlobalPopupControlProgramEditService] ' + 'Get dimgroep list')
        return <Observable<IControlFormOption[]>>this.httpService2.doGetRequest(`control-form/dimgroep/list`, true);
    }
}
